import { Divider } from "antd";

const Gammaked = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          Important Safety Information
        </p>

        <p className="m-2 font-bold">
          What is GAMMAKED?
        </p>

        <p className="m-2">
          GAMMAKED™ [Immune Globulin Injection (Human) 10% Caprylate/Chromatography Purified] is an immune globulin
          injection that is used to treat primary humoral immunodeficiency (PI) in patients 2 years of age and older,
          idiopathic thrombocytopenic purpura (ITP) in adults and children, and chronic inflammatory demyelinating
          polyneuropathy (CIDP) in adults.
        </p>

        <p className="m-2 font-bold">
          What is the most important information I should know about GAMMAKED?
        </p>

        <p className="m-2">
          GAMMAKED should be infused under your skin (in the subcutaneous tissue). DO NOT inject GAMMAKED into a blood
          vessel or directly into a muscle.
        </p>

        <p className="m-2 font-bold underline">
          GAMMAKED May Cause
        </p>

        <ul className="list-decimal font-bold pl-10">
          <li className="m-2">
            Blood Clots (Thrombosis). Blood clots may occur in patients taking immune globulin intravenous (IGIV)
            products, including GAMMAKED. You may be at greater risk for blood clots if you are of advanced age, sit or
            lie for long periods, have a clotting condition or a history of blood clots, take estrogen hormones, have a
            central catheter, have thick blood, and/or if you have other conditions that put you at risk for
            cardiovascular disease. Blood clots may occur even if you do not have any of these known risk factors.
          </li>
          <li className="m-2">
            Impaired kidney function or kidney failure. IGIV products, particularly those that contain sugar (sucrose),
            have been reported to be associated with kidney dysfunction and damage, kidney failure, and death. Kidney
            damage and kidney failure happen more often in patients receiving IGIV products containing sucrose. GAMMAKED
            does not contain sucrose. You may be at greater risk for kidney failure if you have kidney disease,
            diabetes, are over age 65, are seriously dehydrated, have a blood infection (sepsis), have a blood condition
            called paraproteinemia, or take drugs that can damage your kidneys.
          </li>
        </ul>

        <p className="m-2 font-bold">
          CONTRAINDICATIONS
        </p>

        <ul className="list-disc pl-10">
          <li className="m-2 font-bold">
            Do not use GAMMAKED if:
          </li>
          <ul className="list-disc pl-8">
            <li className="m-2">
              You have a history of severe allergic reactions to human immune globulin. Tell your healthcare provider if
              you have had a serious reaction to other medicines that contain human immune globulin. Ask if you are not
              sure.
            </li>
            <li className="m-2">
              You have an immunoglobulin A (IgA) deficiency and have antibodies to IgA and have a history of allergic
              reactions. Tell your healthcare provider if you have an IgA deficiency or ask if you are not sure.
            </li>
          </ul>
        </ul>

        <p className="m-2 font-bold">
          WARNINGS AND PRECAUTIONS
        </p>

        <ul className="list-disc pl-10">
          <li className="m-2">
            Severe allergic reactions may occur with IGIV products, including GAMMAKED. IgA deficient patients who have
            antibodies against IgA are at greater risk of developing severe allergic reactions. Your healthcare provider
            should have medications, such as epinephrine, to immediately treat any sudden severe allergic reactions.
          </li>
          <li className="m-2">
            If you are receiving GAMMAKED, you could experience higher than normal levels of protein in your blood,
            thick blood, or low sodium (salt) in your blood. This may prevent your blood from flowing easily and
            possibly lead to blood clots.
          </li>
          <li className="m-2">
            Brain inflammation or brain swelling called Aseptic Meningitis Syndrome (AMS) may occur infrequently with
            IGIV products, including GAMMAKED, especially if you receive a high dose or a rapid infusion.
          </li>
          <li className="m-2">
            Blood damage called hemolysis and hemolytic anemia can develop after treatment with GAMMAKED. Your
            healthcare provider will closely monitor you for signs and symptoms of hemolysis and hemolytic anemia.
          </li>
          <li className="m-2">
            Swelling of the lungs may occur in patients following IGIV treatment, including GAMMAKED. Your healthcare
            provider will monitor you for signs of lung damage (also known as transfusion-related acute lung injury
            [TRALI]).
          </li>
          <li className="m-2">
            GAMMAKED is made from human blood and, therefore, carries a risk of transmitting infectious agents, such as
            viruses, the agent of the variant Creutzfeldt-Jakob disease (vCJD), or unknown infectious agents. You should
            consult with your healthcare provider if you have any questions or concerns
          </li>
          <li className="m-2">
            Be sure to tell your healthcare provider about your recent history of vaccinations. Live vaccines for
            diseases like measles, mumps, rubella and varicella may not work as well for you while you are receiving
            GAMMAKED. Tell your healthcare provider that you are taking GAMMAKED before you receive any vaccination.
          </li>
        </ul>

        <p className="m-2 font-bold">
          ADVERSE REACTIONS
        </p>

        <ul className="list-disc pl-10">
          <li className="m-2">
            In clinical studies, the most common side effects of GAMMAKED were:
          </li>
          <ul className="list-disc pl-8">
            <li className="m-2">
              Increased cough, stuffy nose, sore throat, headache, asthma, nausea, fever, diarrhea, and sinus infection,
              when administered intravenously to patients with PI.
            </li>
            <li className="m-2">
              Swelling and itching at the injection site, fatigue, headache, upper respiratory infection, joint pain,
              diarrhea, nausea, sinus infection, bronchitis, depression, allergic skin reactions, redness of the skin,
              migraine, muscle pain, viral infection, and fever, when administered subcutaneously to patients with PI.
            </li>
            <li className="m-2">
              Headache, bruising, vomiting, fever, nausea, rash, abdominal pain, back pain, and indigestion in patients
              with ITP.
            </li>
            <li className="m-2">
              Headache, fever, increased blood pressure, chills, rash, nausea, joint pain, and weakness in patients with
              CIDP.
            </li>
          </ul>
          <li>
            During treatment with GAMMAKED, be sure to tell your healthcare provider about any unusual symptoms you experience as they may indicate a possible side effect.
          </li>
        </ul>

        <div>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of
              prescription drugs to the FDA. Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
          <p className="m-2">
            <b>
              Please&nbsp;
              <a
                target="_blank"
                href="/Gammaked-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                click here
              </a>
              &nbsp;for the Full Prescribing Information for complete prescribing details including Boxed Warning,
              contraindications and dosing and administration information.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Gammaked;
